import { useQuery } from '@tanstack/react-query';
import { PASSPORTS_KEY } from 'src/utils/constants/queryKeys';
import { getPassports } from '../services/ims-api/Cases';

export const useGetPassports = (beneId: number, dependentId: number) => {
  return useQuery({
    queryKey: [PASSPORTS_KEY, beneId, dependentId],
    queryFn: () => getPassports(beneId, dependentId),
    enabled: Boolean(beneId || dependentId),
  });
};
